import * as _ from "lodash";

export const getConnectionObject = (event) => {
    return {
        id: event.connection.id,
        connectionId: event.connection.connectionId,
        creationTime: event.connection.creationTime,
        type: event.type,
        userData: parseUserDataFromConnection(event.connection.data)
    }
};

export const removeConnectionObject = (event, connectionArray) => {

    _.remove(connectionArray, function (o) {
        return o.id === event.connection.id
    });

    return connectionArray;
}

export const getSignalObject = (signal) => {
    return {
        id: signal.from.id,
        connectionId: signal.from.connectionId,
        creationTime: signal.from.creationTime,
        type: signal.type,
        text: signal.data,
        userData: parseUserDataFromConnection(signal.from.data),
        createdAt:new Date().getTime()
    }
};

export const parseUserDataFromConnection = (connectionData) => {
    let userDataArray = connectionData.split(","), updateArray = [], object = {};
    _.map(userDataArray, (data) => {
        const _array = data.split("=")
        const key = _array[0], value = _array[1];
        object[key] = value;
    });

    return object;
};

export const getWalletUserSessionDetails = (props) => {
    if (props.moneyblox.hasOwnProperty("user_details") &&
        props.moneyblox.user_details !== null &&
        props.moneyblox.user_details.hasOwnProperty("username") &&
        props.moneyblox.user_details.hasOwnProperty("api_token") &&
        props.moneyblox.user_details.hasOwnProperty("token") &&
        props.moneyblox.hasOwnProperty("wallet_balance")) {

        return {
            username: props.moneyblox.user_details.username,
            api_token: props.moneyblox.user_details.api_token,
            token: props.moneyblox.user_details.token,
            wallet_balance: props.moneyblox.wallet_balance
        }
    } else {
        return {
            username: "",
            api_token: "",
            token: ""
        }
    }
}